var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuzzIdle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 220",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .root { transform-origin: 100px 110px; transform-box: fill-box; }\n  \n        .root { animation: breathe 4.5s ease-in-out infinite; }\n        @keyframes breathe {\n          0%, 100% { transform: translateY(0) scale(1); }\n          50% { transform: translateY(-1.5px) scale(1.018); }\n        } \n      .wing-l { animation: wguil 4s ease-in-out infinite; transform-origin: 80px 70px; transform-box: fill-box; }\n      .wing-r { animation: wguir 4s ease-in-out infinite; transform-origin: 120px 70px; transform-box: fill-box; }\n      @keyframes wguil { 0%,100%{transform:rotate(0);} 50%{transform:rotate(-3deg);} }\n      @keyframes wguir { 0%,100%{transform:rotate(0);} 50%{transform:rotate(3deg);} }\n    \n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "buzzBody2",
    cx: "35%",
    cy: "28%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#ffc83a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b07814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buzzWing2",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e0eef8",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buzzStripe2",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a2412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buzzBow2",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff8ec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c43a7a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, /*#__PURE__*/React.createElement("g", {
    className: "wing-l"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 80,
    rx: 32,
    ry: 20,
    fill: "url(#buzzWing2)",
    stroke: "#2a1a1a",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,62 Q44,72 42,90 M58,62 Q66,78 80,86 M58,80 Q40,82 32,92",
    stroke: "#2a1a1a",
    strokeWidth: 0.9,
    fill: "none",
    opacity: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 72,
    rx: 8,
    ry: 4,
    fill: "white",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    className: "wing-r"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 80,
    rx: 32,
    ry: 20,
    fill: "url(#buzzWing2)",
    stroke: "#2a1a1a",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,62 Q156,72 158,90 M142,62 Q134,78 120,86 M142,80 Q160,82 168,92",
    stroke: "#2a1a1a",
    strokeWidth: 0.9,
    fill: "none",
    opacity: 0.45,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 72,
    rx: 8,
    ry: 4,
    fill: "white",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88,75 Q82,58 76,50",
    stroke: "#2a1a1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,75 Q118,58 124,50",
    stroke: "#2a1a1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 49,
    r: 4,
    fill: "#ff8ec0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 49,
    r: 4,
    fill: "#ff8ec0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 48,
    r: 1.3,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 48,
    r: 1.3,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 48,
    fill: "url(#buzzBody2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11,0 L-2,-7 L-2,7 Z",
    fill: "url(#buzzBow2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0 L2,-7 L2,7 Z",
    fill: "url(#buzzBow2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 3,
    ry: 3.4,
    fill: "#c43a7a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1,
    cy: -1.5,
    rx: 0.9,
    ry: 1.2,
    fill: "white",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 162,
    rx: 30,
    ry: 20,
    fill: "url(#buzzBody2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,158 q27,-12 54,0",
    stroke: "url(#buzzStripe2)",
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,170 q27,10 54,0",
    stroke: "url(#buzzStripe2)",
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,182 L100,190",
    stroke: "#2a1a1a",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86,
    cy: 184,
    rx: 6,
    ry: 4,
    fill: "#3a2412"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114,
    cy: 184,
    rx: 6,
    ry: 4,
    fill: "#3a2412"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 94,
    rx: 11,
    ry: 6,
    fill: "white",
    opacity: 0.55,
    transform: "rotate(-25 80 94)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 121,
    rx: 5,
    ry: 2.6,
    fill: "#ff8ab8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 121,
    rx: 5,
    ry: 2.6,
    fill: "#ff8ab8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 115,
    r: 2.6,
    fill: "#2a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 115,
    r: 2.6,
    fill: "#2a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.4,
    cy: 114.2,
    r: 0.9099999999999999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.4,
    cy: 114.2,
    r: 0.9099999999999999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#2a1a1a",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4,113.4 l-1.8,-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,112.4 l-0.8,-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,112.4 l0.8,-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,113.4 l1.8,-1.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,127.5 Q100,131.5 105,127.5",
    stroke: "#c43a5a",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzzIdle);
export default __webpack_public_path__ + "static/media/buzz-idle.cf4fcdbcf64f3dd23f61111403f0c460.svg";
export { ForwardRef as ReactComponent };